import './App.css';
import { Routes, Route, Navigate } from "react-router-dom";
import WrapperComponent from "./Wrapper Component/WrapperComponent";
import RouterComponent from "./Router Component/RouterComponent";
import Login from "./pages/Login/Login";
import ForgotPassword from "./pages/Login/Forgot password/ForgotPassword";
import LoginCommonOutlet from "./pages/Login/Login Common Outlet/LoginCommonOutlet";
import OTPVerify from "./pages/Login/OTP Verify/OTPVerify";
import ResetPassword from "./pages/Login/Reset Password/ResetPassword";
import Congras from "./pages/Login/Successfull reset Password/Congras";

// Public pages
import TermAndCondition from "./pages/Static Content/Term And Condition/TermAndCondition";
import PrivacyPolicyPublic from './common/Public Page/PrivacyPolicyPublic';
import TermConditionPublic from './common/Public Page/TermConditionPublic';
import { useDispatch, useSelector } from 'react-redux';
import { loggedInState } from './redux/features/AuthSlice';

function App() {

  const {tokenState} = useSelector((state)=>state.Auth);
  const dispatch = useDispatch();
  
  const token = localStorage.getItem('Quixtoken')
    ? JSON.parse(localStorage.getItem('Quixtoken'))
    : null;



  if(token && !tokenState){
    console.log("called:",token)
    dispatch(loggedInState());
  }

  console.log("Tokenstate:",tokenState)


  return (
    <Routes>
      {/* 🌍 PUBLIC ROUTES */}
      <Route path="/privacy-policy" element={<PrivacyPolicyPublic />} />
      <Route path="/terms-and-conditions" element={<TermConditionPublic />} />



        <Route path={"/login"} element={tokenState ? <Navigate to="/" /> :<LoginCommonOutlet />}>
          <Route index element={<Login />} />
          <Route path="forgotPassword" element={<ForgotPassword />} />
          <Route path="OTPVerify" element={<OTPVerify />} />
          <Route path="OTPVerify" element={<OTPVerify />} />
          <Route path="ResetPassword" element={<ResetPassword />} />
          <Route path="Congras" element={<Congras />} />
        </Route>

      {/* 🔒 PROTECTED ROUTES */}
      <Route
        path="/*"
        element={
          <WrapperComponent>
            <RouterComponent />
          </WrapperComponent>
        }
      />
    </Routes>
  );
}

export default App;
